import { render, staticRenderFns } from "./Ntag.vue?vue&type=template&id=09a1b545&scoped=true&"
import script from "./Ntag.vue?vue&type=script&lang=ts&"
export * from "./Ntag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a1b545",
  null
  
)

export default component.exports